module.exports = __webpack_public_path__ + "./worker.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=./worker.js!./src-client-lib/solace/worker.js
// module id = 2509
// module chunks = 0